module.exports = __webpack_public_path__ + "static/ets-dcc26d2977f9df3d8223c9b5dd3cfcf2.jpg";